<div class="grid" id="grid">
  <div class="col-12">
    <div class="grid">
      <div class="flex flex-column col-12">
        <div class="card">
          <div class="p-datatable p-component p-datatable-hoverable-rows">
            <div class="flex align-items-center justify-content-end">
              <div>
                <button (click)="filtersVisible = !filtersVisible" class="p-button-secondary" icon="pi pi-sliders-h"
                        label=" {{'common.filters' | transloco}}"
                        pButton>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column col-12 md:col-4">
        <div class="card">
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'misc.overview.distributionByCountry' | transloco}}</h4>
            <div class="flex flex-column md:flex-row justify-content-center p-fluid">
              <button
                [disabled]="loadingData"
                type="button"
                pButton
                icon="pi pi-bars"
                class="p-button-secondary"
                label=""
                (click)="distributionByCountryAction.toggle($event); exportFileType = ExportFileType.ANALYSIS_DISTRIBUTION_BY_COUNTRY_CHART"
              ></button>
              <p-menu #distributionByCountryAction [popup]="true" [model]="chartActions" id="optionsCountry" appendTo="body">
              </p-menu>
            </div>
          </div>
          <hr>
          <app-generic-graph
            *ngIf="!loadingData"
            [fileName]="'misc.overview.distributionByCountry' | transloco"
            [exportFileType]="ExportFileType.ANALYSIS_DISTRIBUTION_BY_COUNTRY_CHART"
            [data]="distributionByCountryGraph"
            [plotOptions]="plotOptionsPie"
            [pointFormat]="pointFormatPieChart"
            [customSeries]="true"
            [legend]="true"
            height="250"
            name="Value"
            chartType="pie"
            #distributionByCountryChart
          ></app-generic-graph>
          <div *ngIf="loadingData">
            <div class="col-12">
              <p-skeleton width="100%" height="250px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column col-12 md:col-4">
        <div class="card">
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'misc.overview.distributionByState' | transloco}}</h4>
            <div class="flex flex-column md:flex-row justify-content-center p-fluid">
              <button
                [disabled]="loadingData"
                type="button"
                pButton
                icon="pi pi-bars"
                class="p-button-secondary"
                label=""
                (click)="distributionByStateAction.toggle($event); exportFileType = ExportFileType.ANALYSIS_DISTRIBUTION_BY_STATE_CHART"
              ></button>
              <p-menu #distributionByStateAction [popup]="true" [model]="chartActions" id="optionsState" appendTo="body">
              </p-menu>
            </div>
          </div>
          <hr>
          <app-generic-graph
            *ngIf="!loadingData"
            [fileName]="'misc.overview.distributionByState' | transloco"
            [exportFileType]="ExportFileType.ANALYSIS_DISTRIBUTION_BY_STATE_CHART"
            [data]="distributionByStateGraph"
            [plotOptions]="plotOptionsPie"
            [pointFormat]="pointFormatPieChart"
            [customSeries]="true"
            [legend]="true"
            height="250"
            name="Value"
            chartType="pie"
            #distributionByStateChart
          ></app-generic-graph>
          <div *ngIf="loadingData">
            <div class="col-12">
              <p-skeleton width="100%" height="250px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column col-12 md:col-4">
        <div class="card">
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'misc.overview.distributionByLocality' | transloco}}</h4>
            <div class="flex flex-column md:flex-row justify-content-center p-fluid">
              <button
                [disabled]="loadingData"
                type="button"
                pButton
                icon="pi pi-bars"
                class="p-button-secondary"
                label=""
                (click)="distributionByLocalityAction.toggle($event); exportFileType = ExportFileType.ANALYSIS_DISTRIBUTION_BY_LOCALITY_CHART"
              ></button>
              <p-menu #distributionByLocalityAction [popup]="true" [model]="chartActions" id="optionsLocality" appendTo="body">
              </p-menu>
            </div>
          </div>
          <hr>
          <app-generic-graph
            *ngIf="!loadingData"
            [fileName]="'misc.overview.distributionByLocality' | transloco"
            [exportFileType]="ExportFileType.ANALYSIS_DISTRIBUTION_BY_LOCALITY_CHART"
            [data]="distributionByLocalityGraph"
            [plotOptions]="plotOptionsPie"
            [pointFormat]="pointFormatPieChart"
            [customSeries]="true"
            [legend]="true"
            height="250"
            name="Value"
            chartType="pie"
            #distributionByLocalityChart
          ></app-generic-graph>
          <div *ngIf="loadingData">
            <div class="col-12">
              <p-skeleton width="100%" height="250px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column col-12 md:col-8">
        <div class="card">
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'misc.overview.parkAntiquity' | transloco}}</h4>
            <div class="flex flex-column md:flex-row justify-content-center p-fluid">
              <button
                [disabled]="loadingData"
                type="button"
                pButton
                icon="pi pi-bars"
                class="p-button-secondary"
                label=""
                (click)="machinesByAntiquityAction.toggle($event); exportFileType = ExportFileType.ANALYSIS_MACHINES_BY_ANTIQUITY_CHART"
              ></button>
              <p-menu #machinesByAntiquityAction [popup]="true" [model]="chartActions" id="optionsAntiquity" appendTo="body">
              </p-menu>
            </div>
          </div>
          <hr>
          <app-generic-graph
            *ngIf="!loadingData"
            [fileName]="'misc.overview.parkAntiquity' | transloco"
            [exportFileType]="ExportFileType.ANALYSIS_MACHINES_BY_ANTIQUITY_CHART"
            [data]="machinesByAntiquityGraph"
            [categories]="antiquityCategories"
            [pointFormat]="pointFormatAntiquityChart"
            [plotOptions]="plotOptionsColumnChart"
            [dataType]="'category'"
            [customSeries]="true"
            [legend]="false"
            height="250"
            name="Value"
            #machinesByAntiquityChart
          ></app-generic-graph>
          <div *ngIf="loadingData">
            <div class="col-12">
              <p-skeleton width="100%" height="250px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column col-12 md:col-4">
        <div class="card">
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'misc.overview.machinesByModel' | transloco}}</h4>
            <div class="flex flex-column md:flex-row justify-content-center p-fluid">
              <button
                [disabled]="loadingData"
                type="button"
                pButton
                icon="pi pi-bars"
                class="p-button-secondary"
                label=""
                (click)="machinesByModelAction.toggle($event); exportFileType = ExportFileType.ANALYSIS_MACHINES_BY_MODEL_CHART"
              ></button>
              <p-menu #machinesByModelAction [popup]="true" [model]="chartActions" id="optionsModel" appendTo="body">
              </p-menu>
            </div>
          </div>
          <hr>
          <app-generic-graph
            *ngIf="!loadingData"
            [fileName]="'misc.overview.machinesByModel' | transloco"
            [exportFileType]="ExportFileType.ANALYSIS_MACHINES_BY_MODEL_CHART"
            [data]="machinesByModelGraph"
            [plotOptions]="plotOptionsPie"
            [pointFormat]="pointFormatPieChart"
            [customSeries]="true"
            [legend]="true"
            height="250"
            name="Value"
            chartType="pie"
            #machinesByModelChart
          ></app-generic-graph>
          <div *ngIf="loadingData">
            <div class="col-12">
              <p-skeleton width="100%" height="250px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organization">{{'model.organization' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-treeSelect
          [(ngModel)]="organizations"
          [placeholder]="'select.generic' | transloco"
          [propagateSelectionUp]="false"
          [propagateSelectionDown]="false"
          display="chip" appendTo="body"
          [options]="hierarchy"
          [metaKeySelection]="false"
          selectionMode="checkbox"
          id="organization"
        ></p-treeSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!organizations"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false; applyFilters()"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>

<app-export-xls *ngIf="exportVisible"
                [content]="getContentExport()"
                [typeContent]="'MACHINE_PARK'"
                [exportFileType]="exportFileType"
                [categories]="antiquityCategories"
                [typeExport]="'XLSX'"
                [(visible)]="exportVisible">
</app-export-xls>

